import React, { useState } from 'react';
import { v4 } from 'uuid';
import useTranslation from '../../Hooks/useTranslation';
import { EducationMaterialInterface } from '../../Models/EducationMaterials/EducationMaterial';
import { joinClasses } from '../../Utils/className.util';
import MediaViewerModal from '../MediaViewer/MediaViewerModal';
import styles from './EducationMaterial.module.scss';
import EducationMaterialVideo from './EducationMaterialVideo';

interface EducationMaterial {
	item: EducationMaterialInterface;
	onUpdateItem: (item: EducationMaterialInterface) => void;
}
const EducationMaterial: React.FC<EducationMaterial> = ({
	item,
	onUpdateItem,
}) => {
	const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
	const { t } = useTranslation();

	const handleToggleActive = () => {
		item.active = !item.active;
		onUpdateItem(item);
	};

	let component = undefined;
	switch (item.subtype) {
		case 'video':
			component = <EducationMaterialVideo item={item} />;
			break;
		case 'pdf':
			component = (
				<a
					onClick={() => {
						setIsPdfModalOpen(true);
					}}
					className={styles.pdfLink}>
					<img src={item.value.thumbnail} alt={item.name} className='w-100' />
				</a>
			);
			break;
	}

	return (
		<div
			className={joinClasses([
				styles.wrapper,
				item.active && styles.borderActive,
			])}>
			<div className={'d-flex flex-row justify-content-between'}>
				<div
					className={joinClasses([
						styles.checkbox,
						item.active && styles.active,
					])}
					onClick={handleToggleActive}
				/>
				{item.sent && (
					<div className={styles.send}>
						{item.seen ? t('base.seen') : t('base.sent2')}
					</div>
				)}
			</div>
			{component}
			<div className={styles.title}>{item.name}</div>
			<MediaViewerModal
				opened={isPdfModalOpen}
				onClose={() => {
					setIsPdfModalOpen(false);
				}}
				file={{
					id: v4(),
					preview: item.value.link,
					download: item.value.link,
					displayName: item.name,
					type: item.subtype,
				}}
			/>
		</div>
	);
};

export default EducationMaterial;
